import { render } from "./DonationSetup.vue?vue&type=template&id=fc09aede&scoped=true"
import script from "./DonationSetup.vue?vue&type=script&lang=js"
export * from "./DonationSetup.vue?vue&type=script&lang=js"

import "./DonationSetup.vue?vue&type=style&index=0&id=fc09aede&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fc09aede"]])

export default __exports__